import * as action from './actions';

import * as actionTypes from './actionTypes';

import { PAYMENT_DEFAULT_CURRENCY } from 'constants/payments/currency';

import { LS_KEYS } from 'helpers/localStorage';

import { InferValueTypes } from 'types/commonInterfaces';

import { PaymentStore } from 'interfaces/Store/paymentStore';

type ActionType = ReturnType<InferValueTypes<typeof action>>;

export const initialState: PaymentStore = {
    isLoading: false,
    paymentValidate: {},
    paymentMethod: 'PAYPAL',
    paymentConfig: {
        paypal: true,
        applaPay: true,
        sandbox: false,
    },
    solidInited: false,
    bankCardSrc: null,
    payPalLink: null,
    applePay: '',
    initPaymentData: null,
    checkoutOrderId: '',
    currentProduct: null,
    currency: PAYMENT_DEFAULT_CURRENCY,
    exclusiveOfferStatus: false,
    paymentType: null,
    selectedTrialPrice: 0.5,
    subscriptionId: null,
    upsellId: null,
    paymentDiscount: 0,
    validatePaymentData: null,
    oneClickPaymentPrice: null,
    isPaymentScreen: false,
    isCustomPaymentButton: false,
    isLoadingBankCard: true,
    isApplePayAvailable: false,
    merchantData: null,
    merchantDataUpsell: null,
    isHideCustomPaymentButton: false,
    paymentFailToRetenoObj: null,
    skipTrialProduct: null,
    allProductsFromFirstPayment: [],
    isGooglePayAvailable: false,
    isLatamOn: false,
    isUpsellPaid: false,
    isUpsellSubPaid: false,
    guidesProduct: null,
    pageType: null,
};

const PaymentReducer = (state = initialState, action: ActionType) => {
    switch (action.type) {
        case actionTypes.SET_CURRENT_PRODUCT: {
            return {
                ...state,
                currentProduct: action.payload,
            };
        }

        case actionTypes.SET_ORDER_ID:
            return {
                ...state,
                checkoutOrderId: action.payload,
            };

        case actionTypes.SET_SUBSCRIPTION_ID:
            return {
                ...state,
                subscriptionId: action.payload,
            };

        case actionTypes.INIT_SOLID_PAYMENT:
            return {
                ...state,
                solidInited: action.payload,
            };

        case actionTypes.SET_LOADING_STATUS:
            return {
                ...state,
                isLoading: action.payload,
            };

        case actionTypes.SET_PAYMENT_DATA:
            return {
                ...state,
                initPaymentData: action.payload,
            };

        case actionTypes.VALIDATE_PAYMENT_DATA:
            return {
                ...state,
                validatePaymentData: action.payload,
            };

        case actionTypes.INIT_PAYMENT:
            return {
                ...state,
            };

        case actionTypes.SET_BANKCARD_SRC:
            return {
                ...state,
                bankCardSrc: action.payload,
            };

        case actionTypes.VALIDATE_PAYMENT:
            return {
                ...state,
                isLoading: true,
            };

        case actionTypes.CHANGE_PAYMENT_TYPE:
            return {
                ...state,
                paymentMethod: action.payload,
            };

        case actionTypes.SET_UPSELL_PRODUCT_PRICE:
            return {
                ...state,
                oneClickPaymentPrice: action.payload,
            };

        case actionTypes.SET_PAYMENT_CONFIG: {
            const newPaymentConfig = Object.assign({}, state.paymentConfig, action.payload);

            return {
                ...state,
                paymentConfig: newPaymentConfig,
            };
        }

        case actionTypes.VALIDATE_PAYMENT_FAIL:
            return {
                ...state,
                isLoading: false,
                paymentValidate: {
                    isValid: false,
                    message: action.payload,
                },
            };

        case actionTypes.SET_PAYMENT_CURRENCY:
            return { ...state, currency: action.payload };

        case actionTypes.SET_EXCLUSIVE_OFFER:
            return {
                ...state,
                exclusiveOfferStatus: action.payload,
            };

        case actionTypes.SET_PAYMENT_TYPE:
            localStorage.setItem(LS_KEYS.paymentType, action.payload);

            return { ...state, paymentType: action.payload };

        case actionTypes.SET_UPSELL_PRODUCT_ID:
            return {
                ...state,
                upsellId: action.payload,
            };

        case actionTypes.SET_PAYMENT_DISCOUNT:
            return { ...state, paymentDiscount: action.payload };

        case actionTypes.SET_IS_PAYMENT_SCREEN:
            return { ...state, isPaymentScreen: action.payload };

        case actionTypes.SET_CUSTOM_PAYMENT_BUTTON:
            return { ...state, isCustomPaymentButton: action.payload };

        case actionTypes.SET_IS_LOADING_BANK_CARD:
            return {
                ...state,
                isLoadingBankCard: action.payload,
            };

        case actionTypes.SET_MERCHANT_DATA:
            return {
                ...state,
                merchantData: action.payload,
            };

        case actionTypes.SET_MERCHANT_DATA_UPSELL:
            return {
                ...state,
                merchantDataUpsell: action.payload,
            };

        case actionTypes.SET_HIDE_CUSTOM_PAYMENT_BUTTON:
            return { ...state, isHideCustomPaymentButton: action.payload };

        case actionTypes.SET_IS_APPLE_PAY_AVAILABLE:
            return { ...state, isApplePayAvailable: action.payload };

        case actionTypes.SET_PAYMENT_RETENO_ERROR_STORE:
            return {
                ...state,
                paymentFailToRetenoObj: action.payload,
            };

        case actionTypes.SET_SKIP_TRIAL_PRODUCT: {
            return {
                ...state,
                skipTrialProduct: action.payload,
            };
        }

        case actionTypes.SET_ALL_PRODUCTS_FROM_FIRST_PAYMENT:
            return { ...state, allProductsFromFirstPayment: action.payload };

        case actionTypes.SET_IS_GOOGLE_PAY_AVAILABLE:
            return { ...state, isGooglePayAvailable: action.payload };

        case actionTypes.SET_IS_LATAM_ON:
            return { ...state, isLatamOn: action.payload };

        case actionTypes.SET_IS_UPSELL_PAID:
            return { ...state, isUpsellPaid: action.payload };

        case actionTypes.SET_IS_UPSELL_SUB_PAID:
            return { ...state, isUpsellSubPaid: action.payload };

        case actionTypes.SET_GUIDES_PRODUCT:
            return { ...state, guidesProduct: action.payload };

        case actionTypes.SET_PAGE_TYPE:
            return { ...state, pageType: action.payload };

        default:
            return state;
    }
};

export default PaymentReducer;
